import { observer } from "mobx-react-lite";
import { useState,useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
export default observer(function PoliciesComponent(cat,key) {     
    const currentyear = new Date().getFullYear();
    const navigate = useNavigate();  
    return (
        <section data-bs-version="5.1" className="features4 shopm5 cid-uATHtrsOUY" id="afeatures4-2">
        <div className="container">
            <div className="row">
                
            </div>
            <div className="row cars-row justify-content-center">
                <div className="card col-12 col-md-8 col-lg-4">
                    <div className="card-wrapper align-center">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-delivery mobi-mbri"></span>
                        </div>
                        <div className="text-wrap">
                            <h5 className="card-title mbr-fonts-style mb-0 display-7"><strong>Terms and Conditions</strong></h5>
                            <p className="card-text mbr-fonts-style mb-0 display-7">
                            Website rules and regulations
                            </p>
                            <div className="mbr-section-btn"><a href="" className="btn btn-danger display-7">
                                    <span className="mobi-mbri mobi-mbri-arrow-next mbr-iconfont mbr-iconfont-btn"></span>
                                    <a style={{cursor:'pointer'}} onClick={()=>{                                                
                            navigate("/terms");
                        }}>
                        Read More</a>
                                </a></div>
                        </div>
                    </div>
                </div>
                <div className="card col-12 col-md-8 col-lg-4">
                    <div className="card-wrapper align-center">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-undo mobi-mbri"></span>
                        </div>
                        <div className="text-wrap">
                            <h5 className="card-title mbr-fonts-style mb-0 display-7"><strong>Refund/Cancellation</strong></h5>
                            <p className="card-text mbr-fonts-style mb-0 display-7">
                            Refunds and cancellations policy
                            </p>
                            <div className="mbr-section-btn"><a href="" className="btn btn-danger display-7">
                                    <span className="mobi-mbri mobi-mbri-arrow-next mbr-iconfont mbr-iconfont-btn"></span>
                                    <a style={{cursor:'pointer'}} onClick={()=>{                                                
                            navigate("/refund");
                        }}>
                        Read More</a>                                    
                                </a></div>
                        </div>
                    </div>
                </div>
                <div className="card col-12 col-md-8 col-lg-4">
                    <div className="card-wrapper align-center">
                        <div className="iconfont-wrapper">
                            <span className="mbr-iconfont mobi-mbri-cash mobi-mbri"></span>
                        </div>
                        <div className="text-wrap">
                            <h5 className="card-title mbr-fonts-style mb-0 display-7"><strong>Privacy Policy</strong></h5>
                            <p className="card-text mbr-fonts-style mb-0 display-7">
                            We Collect, utilize, and protect data
                            </p>
                            <div className="mbr-section-btn"><a href="" className="btn btn-danger display-7">
                                    <span className="mobi-mbri mobi-mbri-arrow-next mbr-iconfont mbr-iconfont-btn"></span>
                                    <a style={{cursor:'pointer'}} onClick={()=>{                                                
                            navigate("/privacy");
                        }}>
                        Read More</a>
                                </a></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )
})